import { createSlice } from "@reduxjs/toolkit"

const initialState = {
     listName: "", brandId:null,platform:"",listColor:"" ,id:""
}

const addEditWishlist = createSlice({
    name:'createWishlist',
    initialState,
    reducers:{
        addEditWishlistReducer:(state,action)=>{
return {...state,...action.payload}
        }
    }
})

export const {addEditWishlistReducer} = addEditWishlist.actions;
export default addEditWishlist.reducer;